import type { TimelineItem } from '@baby-tracker/contracts';

import { elapsedSeconds, formatDuration } from './activity-format.js';

export type LogKind = 'breast' | 'bottle' | 'solid' | 'sleep' | 'nappy' | 'pump';

function matches(item: TimelineItem, childId: string, kind: LogKind): boolean {
    switch (kind) {
        case 'breast':
            return (
                item.type === 'feeding' &&
                item.feeding.childId === childId &&
                item.feeding.method === 'breast'
            );
        case 'bottle':
            return (
                item.type === 'feeding' &&
                item.feeding.childId === childId &&
                item.feeding.method === 'bottle'
            );
        case 'solid':
            return (
                item.type === 'feeding' &&
                item.feeding.childId === childId &&
                item.feeding.method === 'solid'
            );
        case 'sleep':
            return item.type === 'sleep' && item.sleep.childId === childId;
        case 'nappy':
            return item.type === 'nappy' && item.nappy.childId === childId;
        case 'pump':
            return item.type === 'pumping';
    }
}

export function lastLoggedAt(
    items: TimelineItem[],
    childId: string,
    kind: LogKind,
): string | undefined {
    for (const item of items) {
        if (matches(item, childId, kind)) {
            return item.at;
        }
    }
    return undefined;
}

export function lastHint(instant: string | undefined, now: number): string | undefined {
    if (instant === undefined) {
        return undefined;
    }
    const seconds = elapsedSeconds(instant, now);
    if (seconds < 60) {
        return 'Just now';
    }
    return `Last ${formatDuration(seconds)} ago`;
}

export function recentBottleAmounts(items: TimelineItem[], childId: string): number[] {
    const seen = new Set<number>();
    const amounts: number[] = [];
    for (const item of items) {
        if (
            item.type !== 'feeding' ||
            item.feeding.childId !== childId ||
            item.feeding.method !== 'bottle'
        ) {
            continue;
        }
        const volume = item.feeding.volumeMl;
        if (volume === null || seen.has(volume)) {
            continue;
        }
        seen.add(volume);
        amounts.push(volume);
        if (amounts.length === 3) {
            break;
        }
    }
    return amounts;
}
